import React, { useState } from "react";
import API from "../../services/api.ts";
import { toast } from "react-toastify";

const MedicalDatasetSearch = ({ refreshMedicalDatasets }) => {
    
    const [modality, setModality] = useState("");
    const [anatomy, setAnatomy] = useState("");
    const [condition, setCondition] = useState("");

    // A simple list of modalities; you could also fetch from the server if needed
    const modalities = ["XR", "CT", "MRI", "US"];
    const anatomies = ["Chest", "Abdomen", "Head", "Pelvis"];
    const conditions = ["Fracture", "Tumor", "Infection", "Normal"];

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Use FormData for file (image) upload
            const formData = new FormData();
            formData.append("modality", modality);
            formData.append("anatomy", anatomy);
            formData.append("condition", condition);
            // add the user info from local storage or context if needed
            formData.append("uploaded_by", localStorage.getItem("username"));

            await API.post("/filter_datasets/", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            // Refresh the list
            refreshMedicalDatasets();
        } catch (err) {
            console.error("Failed to query datasets:", err);
            toast.error("Failed to query datasets.");
        }
    };

    return (
        <div style={{ marginTop: "20px" }}>
            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-3">
                    <select
                        className="form-select"
                        value={modality}
                        onChange={(e) => {
                            setModality(e.target.value);
                            handleSubmit(e);
                        }}
                    >
                        <option value="" disabled>Select Modality</option>
                        {modalities.map((mod) => (
                            <option key={mod} value={mod}>
                                {mod}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-3">
                    <select
                        className="form-select"
                        value={anatomy}
                        onChange={(e) => {
                            setAnatomy(e.target.value);
                            handleSubmit(e);
                        }}
                    >
                        <option value="" disabled>Select Anatomy</option>
                        {anatomies.map((ana) => (
                            <option key={ana} value={ana}>
                                {ana}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-3">
                    <select
                        className="form-select"
                        value={condition}
                        onChange={(e) => {
                            setCondition(e.target.value);
                            handleSubmit(e);
                        }}
                    >
                        <option value="" disabled>Select Condition</option>
                        {conditions.map((cond) => (
                            <option key={cond} value={cond}>
                                {cond}
                            </option>
                        ))}
                    </select>
                </div>
            </form>

        </div>
    );
};

export default MedicalDatasetSearch;
